// Import the functions you need from the SDKs you need
import firebase from "firebase";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB90A4xLUIMelKQWpHYa9pYj0WMDtwBLUk",
  authDomain: "notes-b827c.firebaseapp.com",
  projectId: "notes-b827c",
  storageBucket: "notes-b827c.appspot.com",
  messagingSenderId: "306583911585",
  appId: "1:306583911585:web:06d5a91316aa9b6cd3c4e0",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

export { db };
export default firebase;
